<div class="input-wrapper">
  <input
    type="text"
    placeholder="{{ placeholder }}"
    [(ngModel)]="searchQuery"
    (keyup)="onKeyup($event)"
    (keyup.enter)="onSearchClick()"
    (focus)="
      searchServiceHistory.length > 0
        ? (showHistory = true)
        : (showHistory = false)
    "
    (blur)="onBlur($event)"
  />

  <i (click)="onSearchClick()">
    <svg width="17px" height="18px">
      <path
        fill-rule="evenodd"
        d="M9.451,0.886 C5.299,0.886 1.922,4.207 1.922,8.289 C1.922,10.055 2.556,11.678 3.610,12.952 L-0.010,16.512 L1.411,17.909 L5.078,14.303 C6.312,15.174 7.820,15.692 9.451,15.692 C13.602,15.692 16.980,12.371 16.980,8.289 C16.980,4.207 13.602,0.886 9.451,0.886 ZM9.451,13.716 C6.408,13.716 3.932,11.281 3.932,8.289 C3.932,5.296 6.408,2.862 9.451,2.862 C12.494,2.862 14.971,5.296 14.971,8.289 C14.971,11.281 12.494,13.716 9.451,13.716 Z"
      />
    </svg>
  </i>
</div>
<div class="search-history" [ngClass]="{ visible: showHistory }">
  <ul>
    <li class="header-history">Last Searched</li>
    <li
      class="search-item"
      *ngFor="let searchQueryHistory of searchServiceHistory"
      (click)="onClickHistoryItem(searchQueryHistory)"
    >
      {{ searchQueryHistory }}
    </li>
  </ul>
</div>
